import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import PageMeta from '../../modules/PageMeta';
import PageSection from '../../modules/PageSection';
import SidebarColumn from '../../modules/SidebarColumn';
import ContentColumn from '../../modules/ContentColumn';
import PageSidebar from '../../modules/PageSidebar';
import Page from '../../pages/Page';
import Overlay from '../../modules/Overlay';
import InlineButtonPanel from '../../modules/InlineButtonPanel';
import Button from '../../modules/Button';
import LicenceServiceList from '../../modules/LicenceServiceList';

import * as licenceActions from '../../../actions/licences';

import { toggleVisibility } from '../../../services/ui/visibilityToggler';

import styles from './styles.scss';

class AdminManageLicences extends React.Component {

    constructor() {
        super();

        this.state = {
            licenceToDelete: null,
            isRemovingLicence: false,
            licenceVersionsExpanded: []
        }
    }

    componentDidMount() {

        this.props.refreshLicences();
    }

    _toggleLicenceVersions(licenceId, event) {

        event.preventDefault();

        this.setState({
            licenceVersionsExpanded: toggleVisibility(this.state.licenceVersionsExpanded, licenceId)
        });
    }

    _showDeleteLicenceOverlay(licenceToDelete, event) {

        event.preventDefault();

        this.setState({ licenceToDelete });
    }

    _hideDeleteLicenceOverlay() {

        this.setState({ licenceToDelete: null });
    }

    _deleteLicence() {

        this.setState({ isRemovingLicence: true });

        this.props.deleteLicence(this.state.licenceToDelete.id)
            .then(() => this.setState({ licenceToDelete: null, isRemovingLicence: false }));
    }

    render() {

        const { licenceToDelete } = this.state;

        return (
            <Page>
                <PageMeta title="Manage Licences" />

                <SidebarColumn>
                    <PageSidebar />
                </SidebarColumn>

                <ContentColumn>

                    <PageSection>

                        <Link className={styles['new-licence']} to="/admin/new-licence">New Licence</Link>

                        <div className={styles['licence-container']}>
                            {this.props.licences.map(licence => {
                                return (
                                    <div key={licence.id} className={styles['licence']}>

                                        <h2 className={styles['licence-name']}>{ licence.name }</h2>

                                        <span className={styles['last-updated']}>Published: { moment.utc(licence.created_at).local().format('DD/MM/YYYY') }</span>

                                        {this.state.licenceVersionsExpanded.includes(licence.id) &&
                                            <ul className={styles['previous-versions-list']}>
                                                {licence.previous_versions.map(previousLicence => {
                                                    return (
                                                        <li>
                                                            <Link className={styles['previous-licence-name']} to={`/licences/${previousLicence.id}`}>{ previousLicence.name }</Link>
                                                            <span className={styles['previous-licence-date']}>Published: { moment.utc(previousLicence.created_at).local().format('DD/MM/YYYY') }</span>
                                                        </li>
                                                    )
                                                })}
                                            </ul>
                                        }

                                        {licence.previous_versions.length > 0 &&
                                            <div className={styles['licence-actions']}>
                                                <a href="" className={styles['versions-button']} onClick={this._toggleLicenceVersions.bind(this, licence.id)}>
                                                    { this.state.licenceVersionsExpanded.includes(licence.id) ? 'Hide History' : 'Show History' }
                                                </a>
                                            </div>
                                        }

                                        <div className={styles['licence-actions']}>
                                            <Link className={styles['view-button']} to={`/licences/${licence.id}`}>View</Link>
                                            <Link className={styles['edit-button']} to={`/admin/edit-licence/${licence.id}`}>Edit</Link>
                                            <a href="" onClick={this._showDeleteLicenceOverlay.bind(this, licence)} className={styles['delete-button']}>Delete</a>
                                        </div>

                                    </div>
                                )
                            })}
                        </div>

                    </PageSection>

                </ContentColumn>

                {licenceToDelete &&
                    <Overlay onRequestClose={this._hideDeleteLicenceOverlay.bind(this)} className={styles['delete-overlay']} isOpen={true}>
                        <p>
                            Are you sure you want to delete the <strong>{ licenceToDelete.name }</strong> licence?
                        </p>

                        <p>
                            You will be unable to track which users have signed a version of this licence.
                        </p>

                        {licenceToDelete.used_by_service_count > 0 &&

                            <div>
                                <p>
                                    The licence will be detached from the following services:
                                </p>

                                <LicenceServiceList serviceLicences={licenceToDelete.service_licences} />
                            </div>
                        }

                        <InlineButtonPanel>
                            <Button disabled={this.state.isRemovingLicence} onClick={this._deleteLicence.bind(this)}>Yes</Button>
                            <Button onClick={this._hideDeleteLicenceOverlay.bind(this)}>No</Button>
                        </InlineButtonPanel>
                    </Overlay>
                }
            </Page>
        )
    }
}

const mapStateToProps = state => {
    return {
        licences: state.licences.licences
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        refreshLicences() {
            dispatch(licenceActions.refreshAllLicences());
        },
        deleteLicence(licenceId) {
            return dispatch(licenceActions.deleteLicence(licenceId));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminManageLicences);